import { render, staticRenderFns } from "./PlanAdd.vue?vue&type=template&id=045a6605"
import script from "./PlanAdd.vue?vue&type=script&lang=js"
export * from "./PlanAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports